import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getPayments = createAsyncThunk(
  'payment/getPayments',
  async ({ skip, limit, created_from, created_to, is_recurring, order_status, payment_id }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params: {
          ...(skip ? { skip: skip - 1 } : {}),
          ...(limit ? { limit } : {}),
          ...(created_from ? { created_from } : {}),
          ...(created_to ? { created_to } : {}),
          ...(is_recurring ? { is_recurring: is_recurring === "Subscription" ? true : false } : {}),
          ...(order_status ? { order_status } : {}),
          ...(payment_id ? { payment_id } : {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/payments`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const downloadPaymentsList = createAsyncThunk(
  'payment/downloadPaymentsList',
  async ({ skip, limit, created_from, created_to, is_recurring, order_status }, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params: {
          ...(skip ? { skip: skip - 1 } : {}),
          ...(limit ? { limit } : {}),
          ...(created_from ? { created_from } : {}),
          ...(created_to ? { created_to } : {}),
          ...(is_recurring ? { is_recurring: is_recurring === "Subscription" ? true : false } : {}),
          ...(order_status ? { order_status } : {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/payments/payment-list-download`,
        config
      );
      if (response.status === 200) {
        downloadReport(response.data, `Sales Report.csv`);
      }
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

const downloadReport = (blob, filename) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};
